import { getBlockSize } from "@sperrdatei/dto/utils";

import type { BlockCheck } from "@sperrdatei/dto/types";

type BlockCheckResultProps = {
  numbers: BlockCheck | undefined;
  searchedNumber: string;
};

export const BlockCheckResult: React.FC<BlockCheckResultProps> = ({
  numbers,
  searchedNumber,
}: BlockCheckResultProps) => {
  const total = numbers ? numbers.total : 0;

  return (
    <div className="col-xxl-7 col-xl-7 col-lg-10 col-xs-12 mt-0 p-0">
      <table className="table">
        <tbody>
          <tr className="border border-0">
            <td className="border border-0 ps-0" colSpan={3}>
              Block:{" "}
              {numbers ? (
                <strong>
                  0{numbers.prefix}-{numbers.number}
                </strong>
              ) : (
                <strong>{searchedNumber}</strong>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="ps-0">
              Eingetragene Nummern
            </td>
            <td className="text-end">
              <strong>
                <span style={{ whiteSpace: "nowrap" }}>
                  {numbers
                    ? `${total} / ${getBlockSize(numbers.number)}`
                    : "Nicht eingetragen"}
                </span>
              </strong>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="ps-0">
              Privat
            </td>
            <td className="text-end">
              {numbers !== undefined ? `${numbers.private}` : ""}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="ps-0">
              Gewerblich
            </td>
            <td className="text-end">
              {numbers !== undefined ? `${numbers.notPrivate}` : ""}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="ps-0">
              Für alle Befragungen gesperrt
            </td>
            <td className="text-end">
              {numbers !== undefined ? `${numbers.blockedForAllSurveys}` : ""}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="ps-0">
              Für Bevölkerungsbefragungen gesperrt
            </td>
            <td className="text-end">
              {numbers !== undefined
                ? `${numbers.blockedForPopulationSurveys}`
                : ""}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
